<template>
  <div class="col-xl-3 col-sm-6">
    <div class="card border shadow-none me-2">
      <div class="card-body p-3">
        <div class="d-flex mb-2 pb-1 border-bottom">
          <div class="avatar flex-shrink-0 me-2">
            <img
              :src="mop.fullLogoUrl"
              alt=""
              @error="
                (e) =>
                  (e.target.src = require('@/assets/images/img-placeholder.png'))
              "
              class="img-thumbnail border-0"
            />
          </div>
          <div class="flex-grow-1r align-self-center overflow-hidden">
            <h5 class="mb-0 text-truncate">
              <b-link
                @click="() => this.$emit('edit', mop)"
                class="text-primary font-size-14 fw-bold"
              >
                {{ mop.displayName }}</b-link
              >
            </h5>
            <p class="small">Payment Method</p>
          </div>
        </div>


        <b-row>
          <b-col>
            <div class="mb-0 text-dark small fw-bold">
              Status: <span :class="{'text-success':mopStatus == 'Active', 'text-danger':mopStatus == 'Inactive'}">{{ mopStatus }}</span>
            </div>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <toggle-button
              @change="() => this.$emit('toggleStatus', mop)"
              v-model="mopMainStatus"
              color="#e73092"
              :sync="true"
            />
          </b-col>
        </b-row>
      </div>
      <!-- end card body -->
      <div class="btn-group btn-icon" role="group">
        <button
        class="btn btn-outline-light"
          @click="() => this.$emit('delete', mop)"
        >
          <i class="text-danger mdi mdi-delete"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  components: {
    ToggleButton
  },
  props: ["mop"],
  computed: {
    mopMainStatus: {
      get(){
        if(this.mop.status == 'a'){
          return true;
        } else {
          return false;
        }
      },
      set(value){
        if(value){
          this.mop.status = 'a';
        } else {
          this.mop.status = 'i';
        }
      }
    },
    mopStatus: {
      get(){
        if(this.mop.status == 'a'){
          return 'Active';
        } else {
          return 'Inactive';
        }
      }
    }
  }
};
</script>